module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', {
    staticClass: "bg-gray-100 min-h-screen flex flex-col"
  }, [_c('div', {
    staticClass: "bg-gradient-to-b from-secondary to-primary"
  }, [_c('div', {
    staticClass: "px-2 py-3"
  }, [_c('app-header', {
    staticClass: "text-white",
    attrs: {
      "icon": "tools"
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('h1', {
    staticClass: "text-2xl font-semibold tracking-wide"
  }, [_vm._v("Contrôles d'étanchéité")])])]), _vm._v(" "), _c('action-bar', {
    staticClass: "pb-5 mb-2",
    attrs: {
      "back": {
        name: 'home'
      }
    }
  }, [_c('button', {
    staticClass: "btn inline-flex items-center gap-2 bg-white text-alert text-sm font-semibold px-4 py-2 rounded-lg shadow-sm hover:shadow transition",
    on: {
      "click": function($event) {
        return _vm.resetValues(true)
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-trash bg-alert"
  }), _vm._v(" "), _c('span', [_vm._v("Tout effacer")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28"
  }, [_c('div', {
    staticClass: "wrap m-2 sm:m-4"
  }, [_c('form', {
    staticClass: "bg-white rounded-xl shadow-2xl p-4 sm:p-6 space-y-5 w-full max-w-full",
    attrs: {
      "id": "ctrl-multi"
    }
  }, [_c('div', [_c('h2', {
    staticClass: "label"
  }, [_vm._v("\n                        RÉFÉRENCE BON ET / OU NOM TECHNICIEN\n                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ordreTravail),
      expression: "ordreTravail"
    }],
    staticClass: "input",
    attrs: {
      "title": "ref",
      "type": "text",
      "name": "ordre",
      "maxlength": "100",
      "placeholder": "Ex. BT-1234 — Dupont"
    },
    domProps: {
      "value": (_vm.ordreTravail)
    },
    on: {
      "change": function($event) {
        return _vm.changeValue('ordreTravail')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ordreTravail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contractuel),
      expression: "contractuel"
    }],
    staticClass: "peer hidden",
    attrs: {
      "type": "checkbox",
      "id": "contract"
    },
    domProps: {
      "checked": Array.isArray(_vm.contractuel) ? _vm._i(_vm.contractuel, null) > -1 : (_vm.contractuel)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.contractuel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.contractuel = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.contractuel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.contractuel = $$c
        }
      }, function($event) {
        return _vm.changeValue('contractuel')
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "btn check cursor-pointer block text-left border border-gray-300 text-gray-700 px-3 py-3 rounded-md transition-colors duration-200 peer-checked:bg-success peer-checked:text-white peer-checked:border-success",
    attrs: {
      "for": "contract"
    }
  }, [_vm._v("\n                        Intervention contractuelle\n                        "), _c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-check-circle text-white"
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "label"
  }, [_vm._v("\n                        DÉTENTEUR "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    staticClass: "w-full",
    attrs: {
      "id": "id-detenteur",
      "filterable": false,
      "on-change": _vm.loadInstall,
      "options": _vm.detenteursFiltred
    },
    on: {
      "search": _vm.onSearch
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "installations"
  }, [_c('h2', {
    staticClass: "label"
  }, [_vm._v("\n                        INSTALLATIONS CONTROLÉES "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('button', {
    staticClass: "btn hide inline-flex items-center justify-center px-3 py-3 rounded-lg text-white shadow bg-[#EA5E0B] hover:opacity-95 transition",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.scanOtag($event)
      }
    }
  }, [_vm._v("\n                        Scan Otag Install\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "space-y-2"
  }, _vm._l((_vm.installations), function(i) {
    return _c('div', {
      key: i.id,
      staticClass: "checkfull relative"
    }, [_c('input', {
      staticClass: "peer hidden",
      attrs: {
        "title": "install",
        "type": "checkbox",
        "id": 'modification-' + i.id,
        "disabled": _vm.installSelected.indexOf(i) === -1 && _vm.locked === true
      },
      domProps: {
        "value": i.id
      },
      on: {
        "change": _vm.checkInstall
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "btn check cursor-pointer block border border-gray-300 text-gray-700 px-3 py-3 rounded-lg pr-12 transition-colors duration-200 peer-checked:bg-success peer-checked:text-white peer-checked:border-success",
      attrs: {
        "for": 'modification-' + i.id
      }
    }, [(_vm.displayPastille(i) === true) ? _c('div', {
      staticClass: "absolute left-2 top-1/2 -translate-y-1/2 h-2.5 w-2.5 bg-success rounded-full"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pl-4"
    }, [_vm._v("\n                                " + _vm._s(i.nom) + "\n                                " + _vm._s((i.marque) ? ' - ' + i.marque : '') + "\n                                " + _vm._s((i.modele) ? ' - ' + i.modele : '') + "\n                            ")]), _vm._v(" "), (i.fluide !== null && i.fluide.type === 'HFO') ? _c('span', {
      staticClass: "HFO-logo absolute right-12 top-1/2 -translate-y-1/2 bg-white text-black border border-green-800 rounded px-1.5 py-0.5 text-xs"
    }, [_vm._v("HFO")]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "icon-valid"
    })])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.installSelected.length !== 0),
      expression: "installSelected.length !== 0"
    }],
    ref: "validation",
    staticClass: "pt-2 space-y-4"
  }, [_c('div', [_c('h2', {
    staticClass: "label"
  }, [_vm._v("\n                            CONTRÔLE D'ÉTANCHÉITÉ "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "checkfull relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noFuite),
      expression: "noFuite"
    }],
    staticClass: "peer hidden",
    attrs: {
      "type": "checkbox",
      "id": "nofuite",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.noFuite) ? _vm._i(_vm.noFuite, "1") > -1 : (_vm.noFuite)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.noFuite,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.noFuite = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.noFuite = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.noFuite = $$c
        }
      }, function($event) {
        return _vm.changeValue('noFuite')
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "btn check blue cursor-pointer block text-left border border-gray-300 text-gray-700 px-3 py-3 rounded-lg transition-colors duration-200 peer-checked:bg-success peer-checked:text-white peer-checked:border-success",
    attrs: {
      "for": "nofuite"
    }
  }, [_vm._v("\n                                Aucune fuite constatée\n                                "), _c('i', {
    staticClass: "icon-valid"
  })])])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "label"
  }, [_vm._v("\n                            ENTRETIEN-CONTRÔLE\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 sm:grid-cols-2 gap-3"
  }, [_c('div', {
    staticClass: "checkfull relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nettoyage),
      expression: "nettoyage"
    }],
    staticClass: "peer hidden",
    attrs: {
      "type": "checkbox",
      "id": "nettoyage",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.nettoyage) ? _vm._i(_vm.nettoyage, "1") > -1 : (_vm.nettoyage)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.nettoyage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.nettoyage = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.nettoyage = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.nettoyage = $$c
        }
      }, function($event) {
        return _vm.changeValue('nettoyage')
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "btn check blue cursor-pointer block text-left border border-gray-300 text-gray-700 px-3 py-3 rounded-lg transition-colors duration-200 peer-checked:bg-success peer-checked:text-white peer-checked:border-success",
    attrs: {
      "for": "nettoyage"
    }
  }, [_vm._v("\n                                    Nettoyage de base réalisé\n                                    "), _c('i', {
    staticClass: "icon-valid"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkfull relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ctrlFonctionnement),
      expression: "ctrlFonctionnement"
    }],
    staticClass: "peer hidden",
    attrs: {
      "type": "checkbox",
      "id": "ctrlFonctionnement",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.ctrlFonctionnement) ? _vm._i(_vm.ctrlFonctionnement, "1") > -1 : (_vm.ctrlFonctionnement)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.ctrlFonctionnement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ctrlFonctionnement = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.ctrlFonctionnement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ctrlFonctionnement = $$c
        }
      }, function($event) {
        return _vm.changeValue('ctrlFonctionnement')
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "btn check blue cursor-pointer block text-left border border-gray-300 text-gray-700 px-3 py-3 rounded-lg transition-colors duration-200 peer-checked:bg-success peer-checked:text-white peer-checked:border-success",
    attrs: {
      "for": "ctrlFonctionnement"
    }
  }, [_vm._v("\n                                    Contrôle de bon fonctionnement réalisé\n                                    "), _c('i', {
    staticClass: "icon-valid"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "space-y-4"
  }, [_c('h2', {
    staticClass: "text-lg font-medium mb-4 uppercase text-secondary"
  }, [_vm._v("\n                            SIGNATURE\n                        ")]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Nom signataire "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nomSignataire),
      expression: "nomSignataire"
    }],
    staticClass: "input",
    attrs: {
      "title": "signName",
      "type": "text",
      "name": "nom_acquereur",
      "required": "",
      "maxlength": "255",
      "placeholder": "Nom et prénom"
    },
    domProps: {
      "value": (_vm.nomSignataire)
    },
    on: {
      "change": function($event) {
        return _vm.changeValue('nomSignataire')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nomSignataire = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Fonction signataire "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fonctionSignataire),
      expression: "fonctionSignataire"
    }],
    staticClass: "input",
    attrs: {
      "title": "signFunction",
      "type": "text",
      "name": "nom_acquereur",
      "required": "",
      "maxlength": "255",
      "placeholder": "Fonction"
    },
    domProps: {
      "value": (_vm.fonctionSignataire)
    },
    on: {
      "change": function($event) {
        return _vm.changeValue('fonctionSignataire')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fonctionSignataire = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6 w-full"
  }, [_c('a', {
    staticClass: "btn add btn-full inline-flex items-center justify-center gap-3 rounded-lg px-3 py-3 font-semibold transition shadow block !w-full !mx-0",
    class: _vm.interventionIsOk ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-500 cursor-not-allowed',
    attrs: {
      "id": "main-action",
      "aria-disabled": !_vm.interventionIsOk,
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.triggerSignature($event)
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-sign",
    class: _vm.interventionIsOk ? 'bg-white' : 'bg-gray-500'
  }), _vm._v(" "), _c('strong', [_vm._v("Signer et Clôturer les fiches")])]), _vm._v(" "), _c('a', {
    staticClass: "btn add btn-full cloturer inline-flex items-center justify-center gap-3 rounded-lg px-3 py-3 font-semibold transition shadow block !w-full !mx-0",
    class: _vm.interventionIsOkWithNoSignature ? 'bg-success text-white' : 'bg-gray-200 text-gray-500 cursor-not-allowed',
    style: (_vm.interventionIsOkWithNoSignature ? 'background-color: #86bc24' : ''),
    attrs: {
      "aria-disabled": !_vm.interventionIsOkWithNoSignature,
      "href": "javascript:void(0)",
      "id": "clotureWithoutSignature"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.triggerSignatureWithNoSignature($event)
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-close-circle",
    class: _vm.interventionIsOkWithNoSignature ? 'bg-white' : 'bg-gray-500'
  }), _vm._v(" "), _c('strong', [_vm._v("Clôturer les fiches détenteur absent")])])]), _vm._v(" "), _c('signature-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    attrs: {
      "signature": _vm.signatureSignataire,
      "clearOnClose": true
    },
    on: {
      "signatureUpdated": _vm.updateSignature,
      "close": function($event) {
        _vm.showModal = false
      }
    }
  })], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7d789fc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fiches/multictrl/MultiCtrlEtanch.vue
// module id = 1051
// module chunks = 0